import {MetricValue} from '../analytics/analytics.types';

const attributionAnalyticsMetrics: Partial<MetricValue>[] = [
  MetricValue.ClickThroughConversion,
  MetricValue.ViewThroughConversions,
  MetricValue.EngagementThroughConversions,
];

export {attributionAnalyticsMetrics};
